import React from 'react';
import { 
  Box, 
  Paper, 
  Typography,
} from '@mui/material';
import { TripRecommendation } from '../api/tripService';

const DataPanel: React.FC<{ data: TripRecommendation | null }> = ({ data }) => {
  return (
    <Box sx={{ height: '100%' }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 2, 
          height: '100%',
          bgcolor: 'background.paper'
        }}
      >
        <Typography variant="h6" gutterBottom>
          Trip Details
        </Typography>

        {data ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {data.attractions.map((attr, index) => (
                <Paper key={index} elevation={2} sx={{ display: 'flex', padding: 2, alignItems: 'center' }}>
                  <img src={attr.photo_url} alt={attr.name} style={{ width: 150, height: 150, borderRadius: 8 }} />
                  <Box sx={{ marginLeft: 2 }}>
                    <Typography variant="h6">{attr.name}</Typography>
                    <Typography variant="body2" color="text.secondary">{attr.description}</Typography>
                    <a href={attr.google_url} target="_blank" rel="noopener noreferrer">
                        <button style={{ marginTop: 8 }}>View on Google</button>
                    </a>
                  </Box>
                </Paper>
              ))}
            </Box>
          </Box>
        ) : (
          <Typography variant="body1" sx={{ mt: 2 }}>
            Start chatting with Trip Mentor to see your trip details here.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default DataPanel; 